export default __webpack_public_path__ + "static/media/AvatarKids-19.5633aef2.png";